import React, { useEffect, useState,useContext } from "react";
import { useNavigate } from "react-router-dom";
import { transactionService } from "../services/transactionService";
import Navbar from "../components/Navbar";
import Summary from "../components/Summary";
import SpendingWallet from "../components/SpendingWallet";
import RecentTransactions from "../components/RecentTransactions";
import AddTransactionModal from "../components/AddTransactionModal";
import Footer from "../components/Footer";
import { TransactionContext } from "../context/TransactionContext";

const HomePage = () => {
  const { shouldRefresh } = useContext(TransactionContext);

  const navigate = useNavigate();
  const [transactions, setTransactions] = useState([]);
  const [totalExpenses, setTotalExpenses] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [newTransaction, setNewTransaction] = useState({
    type: "expense",
    amount: "",
    category: "",
    description: "",
    date: new Date().toISOString(),
  });
  useEffect(() => {
    fetchTransactions();
  }, [shouldRefresh]); // Re-fetch when shouldRefresh changes

  useEffect(() => {
    const token = localStorage.getItem("idToken");
    if (!token) {
      navigate("/login");
      return;
    }
    fetchTransactions();
  }, [navigate]);

  const fetchTransactions = async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await transactionService.getAllTransactions();

      setTransactions(data.slice(0, 6));
      calculateTotalExpenses(data);
    } catch (error) {
      console.error("Error fetching transactions:", error);
      setError("Failed to load transactions.");
    } finally {
      setLoading(false);
    }
  };

  const calculateTotalExpenses = (transactions) => {
    const now = new Date();
    const currentMonth = now.getMonth();
    const currentYear = now.getFullYear();

    const total = transactions
      .filter((t) => {
        const transactionDate = new Date(t.date);
        return t.type === "expense" && 
               transactionDate.getMonth() === currentMonth &&
               transactionDate.getFullYear() === currentYear;
      })
      .reduce((sum, t) => sum + t.amount, 0);
    setTotalExpenses(total);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewTransaction((prev) => ({
      ...prev,
      [name]: name === "amount" ? parseFloat(value) : value,
    }));
  };

  const handleAddTransaction = async () => {
    if (!newTransaction.category || !newTransaction.amount) {
      alert("Please fill in all required fields.");
      return;
    }

    try {
      const transaction = await transactionService.addTransaction({
        ...newTransaction,
        date: new Date().toISOString(),
      });

      setTransactions((prev) => [transaction, ...prev].slice(0, 6));
      calculateTotalExpenses([transaction, ...transactions]);
      setIsModalOpen(false);
      setNewTransaction({
        type: "expense",
        amount: "",
        category: "",
        description: "",
      });
    } catch (error) {
      console.error("Error adding transaction:", error);
      alert("Failed to add transaction.");
    }
  };

  

  return (
    <div style={{ backgroundColor: "#ffffff", minHeight: "100vh" }}>
      
      <Summary totalExpenses={totalExpenses} />
      <SpendingWallet totalExpenses={totalExpenses} />
      <RecentTransactions
        transactions={transactions}
        loading={loading}
        error={error}
      />
      <AddTransactionModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        newTransaction={newTransaction}
        handleInputChange={handleInputChange}
        handleAddTransaction={handleAddTransaction}
      />
      <Footer onAddTransaction={() => setIsModalOpen(true)} />
    </div>
  );
};

export default HomePage;



